module.exports = __webpack_public_path__ + "static/media/apple.d21f92b2.svg";